import { toggleMainMediaStatus } from 'actions/mediaActions';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../../Buttons/Button';
import VolumeControl from './VolumeControl/VolumeControl';
import AudioSlider from './AudioSlider/AudioSlider';
import './AudioPlayer.scss';

// A NEW reusable audio player
// (in the Hotspot modal)

const AudioPlayer = ({ className, src, id }) => {
  const { isMainMediaPlaying } = useSelector(state => state.media);
  const dispatch = useDispatch();

  const [percentage, setPercentage] = useState(0);
  const [duration, setDuration] = useState(0);
  const [playing, setPlaying] = useState(false);

  const audioRef = useRef(null);
  const audioEl = audioRef.current;

  const toggleAudioPlaying = () => {
    // consider moving this out of the component to make this TB agnostic.
    if (isMainMediaPlaying) dispatch(toggleMainMediaStatus(false));

    if (playing && audioEl.currentTime !== duration) audioEl.pause();
    else audioEl.play().catch(e => console.error(e));

    setPlaying(!playing);
  };

  const updateAudioPlayback = e => {
    const { currentTime, duration } = e.currentTarget;

    if (currentTime >= duration) {
      setPlaying(false);
      setPercentage(0);
    } else {
      const percent = ((currentTime / duration) * 100).toFixed(2);
      setPercentage(+percent);
    }
  };

  const setAudioData = ({ target }) => {
    setDuration(target.duration);
  };

  const handleRangeChange = e => {
    const { valueAsNumber } = e.target;

    audioEl.currentTime = (duration / 100) * valueAsNumber;
    setPercentage(valueAsNumber);
  };

  return (
    <div className={`audio-player__wrapper ${className}`}>
      <div className="audio-player-control">
        <Button
          className="audio-player__audio-ctrl_play"
          handleClick={toggleAudioPlaying}
          aria-label={playing ? 'Pause' : 'Play'}
        >
          <i aria-hidden="true" className="material-icons play-or-pause">
            {playing ? 'pause' : 'play_arrow'}
          </i>
        </Button>
        <div className="audio-slider__wrapper">
          <AudioSlider onChange={handleRangeChange} percentage={percentage} />
        </div>
        <audio
          id={`audio_element_${id}`}
          className={`audio-player__audio`}
          ref={audioRef}
          onTimeUpdate={updateAudioPlayback}
          onLoadedData={setAudioData}
        >
          <source src={src} />
        </audio>
      </div>
      <VolumeControl className="audio-player-volume" audioRef={audioRef} />
    </div>
  );
};

export default AudioPlayer;
